import React, {Component} from "react";
import Loader from "../../../../../Common/Component/Loader";
import AddProposal from "./AddProposal";
import {isEmpty, map} from "lodash";
import {message} from "antd";
import moment from "moment-timezone";
import CustomMap from "../../../../ProposalDetail/Component/Common/CustomMap";
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// service type mapping
const SERVICE_TYPE_MAPPING = {
  pet_waste_stations: 'Pet Waste Stations',
  pet_waste_station_bags: 'Pet Waste Station Bags',
  pet_waste_station_service: 'Pet Waste Station Service',
  common_area_cleaning: 'Common Area Cleaning',
  trash_can_service: 'Trash Can Service',
  repair: 'Repair',
  other: 'Other'
}

class Proposal extends Component {
  state = {
    loader: false,
    selectedView: 0,
    proposalList: {},
    selectedProposal: {},
    isEdit: false,
    quoteDetail: {},
    allProposal: {}
  }

  componentDidMount = () => {
    const {getQuoteById, quoteId, addServiceClicked} = this.props;
    this.setState({loader: true})
    this.getProposalList()
    getQuoteById && getQuoteById(quoteId)
    if (addServiceClicked) {this.onChangeView(1)}
  }

  getProposalList = () => {
    const { getCommercialProposal, quoteId } = this.props;
    this.setState({loader: true})
    getCommercialProposal && getCommercialProposal({commercial_quote__uuid: quoteId})
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const {allProposal} = this.state;
    this.setState({loader: false});
    // get commercial proposal
    if (Object.keys(nextProps?.CommercialProposal?.getCommercialProposal).length > 0
      && JSON.stringify(nextProps?.CommercialProposal?.getCommercialProposal) !== JSON.stringify(allProposal)) {
      let closedList = [], list = [], approvedList = [];
      map(nextProps?.CommercialProposal?.getCommercialProposal?.results, (obj) => (obj.proposal_status === 'closed' || obj.proposal_status === "lost") ? closedList.push(obj) : obj.proposal_status === "service_activated" ? approvedList.push(obj) : list.push(obj))
      this.setState({allProposal: nextProps?.CommercialProposal?.getCommercialProposal, proposalList: {results: list}, closedList: {results: closedList}, approvedList});
    }

    // get quote detail
    if (Object.keys(nextProps?.CommercialProposal?.getQuoteDetail).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.getQuoteDetail) !== JSON.stringify(this.props?.CommercialProposal?.getQuoteDetail)) {
      this.setState({ quoteDetail: nextProps?.CommercialProposal?.getQuoteDetail });
    }
  }

  // on change view
  onChangeView = (value) => {
    this.setState({ selectedView: value })
    if (value === 1) {this.props.toggleSidebar(false)} else {this.props.toggleSidebar(true)}
  };

  // render add new box
  renderAdditionalProposalBox = () => {
    return (
      <div className="card add-card">
        <h5>Create a new proposal</h5>
        <p>{`For additional businesses under the same company`}</p>
        <button className="btn btn-warning lg-btn" onClick={() => this.setState({isEdit: false}, () => {
          this.onChangeView(1)
        })}>Add New Proposal</button>
      </div>
    )
  }

  // render proposal overview
  renderProposalOverview = (item, isClose = false) => {
    const address = item?.commercial_quote?.address || {};
    let total = 0;
    map(item?.inner_proposals, (x) => {
      map(x?.line_items, (obj) => total+= parseInt(obj.total))
    })
    let _markers = [], multiple_locations = item?.multiple_locations
    if (multiple_locations) {
      let locations = multiple_locations?.split('MULTIPOINT')[1]
      locations = locations?.trim().substr(1, locations.trim().length - 2)
      let temp = locations?.split(', ')
      map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
    } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
      _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
    }

    return (
      <React.Fragment>
        {(!isClose && !isEmpty(_markers)) ? <div className="map">
          <CustomMap markers={_markers} />
        </div>: ''}
        <div className="plr-15">
          <span className="snum mt-20">{item?.proposal_number}</span>
          {/* <span className="snum mt-20">{!isEmpty(address) ? `${address?.state}-${address?.zip_code}` : '-'}</span> */}
          <h5 className="sadd">{!isEmpty(address) ? `${address?.address}, ${address?.city}, ${address?.state} ${address?.zip_code}` : '-'}</h5>
          <span className="altude">{!isEmpty(address?.geo_location?.latitude) ? `${address?.geo_location?.latitude}, ${address?.geo_location?.longitude}` : ``}</span>
          <div className="active_service_list">
            <div className="flex">
              <div>
                <b>Proposal Date</b>
                <span>{item?.proposal_date ? moment(item?.proposal_date).format('ddd, MMM DD') : item?.commercial_quote?.proposal_due ? moment(item?.commercial_quote?.proposal_due).format('ddd, MMM DD') : ''}</span>
              </div>
              <div>
                <b>Amount</b>
                <span>${formatToCurrency(total)}</span>
              </div>
              {isClose ? <div /> : <div>
                {/*<b>Probability</b>
                <span>-</span>*/}
              </div>}
            </div>
          </div>
          <hr/>
          <div className="sdetail">
            <div className="subs">
              <strong>Subscription</strong>
              <span className=" d-flex justify-content-between">
                <div className="mr-2">
                  {map(item?.inner_proposals, (x) => {
                    return map(x?.line_items, (obj, index) => 
                      <div key={index}>
                        {obj?.frequency ? `${FREQUENCY_MAPPING[obj?.frequency]} service, ${SERVICE_TYPE_MAPPING[obj?.item]}` : SERVICE_TYPE_MAPPING[obj?.item]}
                      </div>)
                  })}
                </div>
                <strong>${formatToCurrency(total)}</strong>
              </span>
            </div>
          </div>
        </div>
        {isClose ? '' : <div className="total flex plr-15">
          <h5>Total per visit</h5>
          <h5>${total}</h5>
        </div>}
      </React.Fragment>
    )
  }

  // render proposal detail
  renderProposalDetail = (item, index, isClose = false) => {
    return (
      <React.Fragment key={`service${index}`}>
        <div className="card">
          <div className="card-body pt-0">
            {this.renderProposalOverview(item, isClose)}
            {(isClose && item?.proposal_status !== "service_activated") ? <button
              className="btn btn-warning btn-full mt-20 mb-10"
              onClick={() => {
                this.setState({loader: true})
                this.props.patchCommercialProposal(item?.uuid, {proposal_status: 'enquiry'});
                setTimeout(() => this.getProposalList(), 1500)
              }}
            >Re-activate Proposal</button> :
              !(item?.proposal_status === 'lost') ? <div className="plr-15">
                <button
                  className="btn btn-warning btn-full mt-20 mb-10"
                  onClick={() => this.setState({isEdit: true, selectedProposal: item, viewApproved: item?.proposal_status === 'service_activated'}, () => {
                    this.onChangeView(1)
                  })}
                >{item?.proposal_status === 'service_activated' ? 'View Approved Proposal' : 'View Single Proposal'}</button>
              </div> : ''}
          </div>
        </div>
      </React.Fragment>
    )
  }

  // render All Proposal
  renderAllProposal = () => {
    const {proposalList, closedList, approvedList} = this.state;
    return (
      <React.Fragment>
        <div className="flist allservice pb-0">
          {
            map(proposalList?.results, (item, index) => this.renderProposalDetail(item, index, false))
          }
          {proposalList?.results?.length > 0 ? '' : this.renderAdditionalProposalBox()}
        </div>
        {/*In-active Service*/}
        <span className="hrline"><small>Inactive</small></span>
        <div className="flist allservice pb-0">
          {
            map(closedList?.results, (item, index) => this.renderProposalDetail(item, index, true))
          }
        </div>
        {/*approved Service*/}
        <span className="hrline"><small>Approved</small></span>
        <div className="flist allservice pb-0">
          {
            map(approvedList, (item, index) => this.renderProposalDetail(item, index, true))
          }
        </div>
      </React.Fragment>
    )
  }

  renderAddProposal = () => {
    const {isEdit, selectedProposal, quoteDetail, viewApproved} = this.state;

    return (
      <React.Fragment>
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li className={"cursor_pointer"}><span onClick={() => {
              this.onChangeView(0)
            }}>Proposal</span></li>
            <li><span>{quoteDetail?.first_name ? `${quoteDetail?.first_name} ${quoteDetail.last_name}` : ''}</span></li>
          </ul>
        </div>
        <AddProposal
          history={this.props.history}
          quoteId={this.props.quoteId}
          quoteDetail={quoteDetail}
          tabChange={this.props.tabChange}
          onChangeView={this.onChangeView}
          isEdit={isEdit} // for edit proposal
          viewApproved={viewApproved}
          selectedProposal={selectedProposal} // for edit proposal
          // API
          getQuoteId={this.props.getQuoteById}
          getProposalList={this.getProposalList}
          getCommercialProposal={this.props.getCommercialProposal}
          getCommercialProposalById={this.props.getCommercialProposalById}
          addCommercialProposal={this.props.addCommercialProposal}
          addInnerCommercialProposal={this.props.addInnerCommercialProposal}
          updateInnerCommercialProposal={this.props.updateInnerCommercialProposal}
          patchCommercialProposal={this.props.patchCommercialProposal}
          sendProposalMail={this.props.sendProposalMail}
          getProposalPdf={this.props.getProposalPdf}
          deleteProposalLineItems={this.props.deleteProposalLineItems}
          deleteInnerProposal={this.props.deleteInnerProposal}
          getBDA={this.props.getBDA}
          editFieldOffice = {this.props.editFieldOffice}
          // Reducers
          CommercialProposal={this.props.CommercialProposal}
          EditFieldOffice = {this.props.EditFieldOffice} />
      </React.Fragment>
    )
  }

  // render views
  renderViews = () => {
    const { selectedView } = this.state;

    switch (selectedView) {
    case 0:
      return this.renderAllProposal();
    case 1:
      return this.renderAddProposal();
    default:
      return this.renderAllProposal()
    }
  }

  render() {
    const {loader} = this.state;
    return (
      <div className="block-row p-0">
        <div className="container">
          {loader && <Loader />}
          {this.renderViews()}
        </div>
      </div>
    )
  }
}

export default Proposal